// action
import {
  loginIn,
  ajaxEmailCode_v3,
  ajaxSendVerifyCode,
  ajaxSendVerifyCodeByGG,
  signUp,
  ajaxInviteCodeStatus,
  ajaxGetAbleList,
  ajaxGetInviteCode,
  ajaxGetUserInfo,
  ajaxIPInfo,
  ajaxHardList,
  ajaxDeviceDetail,
  ajaxAllRevenue,
  ajaxLogout,
  forgetPassword,
  ajaxChangePw,
  ajaxRecommendInfo,
  ajaxRecommendCount,
  ajaxUnbindHard,
  ajaxWalletAddress,
  ajaxBindAddress,
  ajaxVertifUrl,
  ajaxCommitWithdrawal,
  ajaxWithdrawalBalance,
  ajaxUnbindAddress,
  ajaxWithdrawalList,
  ajaxDeviceNotes,
  ajaxRevenueDetail,
  ajaxInviteDetail,
  ajaxDeviceWatchDetail,
  ajaxNetworkContribution,
  ajaxDeviceOverview,
  ajaxPcdnFlow,
  ajaxRestartDevice,
  ajaxLastSevenDayPrice,
  ajaxCommitBuyBack,
  ajaxBuyBackList,
  ajaxBuybackAddress,
  ajaxBuyBackAuth,
  ajaxTaskSchedule,
  ajaxDialConfig,
  ajaxCommitDial,
  ajaxDeleteDial,
  ajaxGetOneDial,
  ajaxGetContact,
  ajaxSetContact,
  ajaxSetStandardNode,
  ajaxGetStandardNode,
  ajaxDeleteNode,
  ajaxSetNodesDialConfig,
  ajaxSetAdminNodesDialConfig,
  ajaxAdminStandardNode,
  ajaxAdminContact,
  ajaxSetNotify,
  ajaxPasswordByBcode,
  ajaxExchangeInfo,
  ajaxCommitExchange,
  ajaxExchangeList,
  ajaxJDOrderPass,
  ajaxDialStatus,
  ajaxUpdateBand,
  ajaxNodeInfoByCode,
  ajaxWhiteBalance,
  ajaxServerByAdmin,
  ajaxUpdateByAdmin,
  ajaxInsertCmbdByAdmin,
  ajaxGetRedisStatus,
  ajaxLastSevenRevenue,
  ajaxServerLabel,
  ajaxLimitExchange,
  ajaxSetStatus,
  ajaxSetTask,
  ajaxGetStatus,
  ajaxEmailToList,
  ajaxEmailAuth,
  ajaxUserList,
  ajaxSendEmail,
  ajaxGetZFBInfos,
  ajaxChangeZFBInfos,
  ajaxAutoWithStatus,
  ajaxAutoWithUserList,
  ajaxGetCollection,
  ajaxSetCollection,
  ajaxPermissionLevel,
  ajaxSetPayment,
  ajaxSetPaymentWithStatus,
  ajaxGetDevErr,
  ajaxGetDevErrBymac,
  ajaxSetServerTag,
  ajaxActivityRevenue,
  ajaxActivityAllRevenue,
  ajaxTaskAcceptanceRes,
  ajaxGetBillDetails,
  ajaxUpdateBillStatus,
  ajaxGetBillBps,
  ajaxGetDialByHostname,
  ajaxGetServerByDialID,
  ajaxSetDial,
  ajaxSavedStatus,
  ajaxGetGaps,
  ajaxGetDeviceAcceptance,
  ajaxSetDeviceAcceptance,
  ajaxSetDeviceDeployment,
  ajaxRecordDownloadCenter,
  ajaxGetStandardNodeHostNameAndBcode,
  ajaxGetetOutFlowRes,
  ajaxGetAbnormalDisk,
  ajaxExportDialErrInfo,
} from './getData';

import {
  ajaxWechatInfo,
  ajaxWechatEmail,
  ajaxUnbindWechat,
  ajaxDeviceStatus,
  ajaxWechatTelFromEmail,
  ajaxWechatBalance,
  ajaxWechatSevenDayPrice,
  ajaxWechatCommitBuyBack,
  ajaxWechatExchangeInfo,
  ajaxWechatCommitExchange,
  ajaxWechatAccountUnify,
} from './getWechatData';

import {
  ajaxAutoWithList,
  ajaxOperateBalance,
  ajaxBalanceList,
  ajaxInfo,
  ajaxBuybackStatus,
  ajaxUnbindDev,
  ajaxCalculateBill,
  ajaxGetBillRecordList,
  ajaxGetBillAuth,
  ajaxUploadSupplyBill,
  ajaxGetBusiness,
  ajaxDelSupplyBill,
} from './getCrmData';
import moment from 'moment';
import { getCookie } from '@/utils/utils';

import {
  LOGIN_IN,
  INVITECODE_STATUS_CODE,
  GET_USER_INFO,
  GET_COUNTRY_INFO,
  GET_HARDLIST,
  GET_ALL_RENVUE,
  GET_RECOMMEND_INFO,
  GET_RECOMMEND_COUNT,
  GET_WALLET_ADDRESS,
  GET_WALLET_STATUS,
  GET_MAINLAND_LIST,
  GET_NON_MAINLAND_LIST,
  GET_WITHDRAWAL_LIST,
  GET_BALANCE,
  GET_CALCULATE_LIST,
  GET_WITHDRAWAL_STAUTS,
  GET_SEARCH_LIST,
  GET_RENVUE_DETAIL,
  GET_INVITE_DETAIL,
  GET_NETWORK_CONTRIBUTION,
  GET_DEVICE_OVERVIEW,
  SET_FILTER_TYPE,
  SET_LAST_SEVEN_PRICE,
  BUYBACK_LIST,
  BUYBACK_AUTH,
  GET_WECHAT_INFO,
  GET_DIAL_CONFIG,
  GET_Node_CONFIG,
  GET_EXCHANGE_INFO,
  GET_EXCHANGE_LIST,
  GET_DIAL_STATUS,
  GET_WECHAT_BANLANCE,
  GET_WECHAT_SEVENDAYPRICE,


  GET_BUSINESS,
} from './mutation-types';
import router from '../router';

const NO_CONTENT = 'NO_CONTENT';

export default {
  async login({ commit }, params) {
    const res = await loginIn(params);
    if (res.code === 200) {
      commit(LOGIN_IN, true);
    } else {
      commit(LOGIN_IN, false);
    }
    return res;
  },
  async logout({ commit }) {
    const res = await ajaxLogout();
    commit(LOGIN_IN, false);
    router.push({ name: 'login' });
    return res;
  },
  async sendEmailCode_v3({ commit }, params) {
    const res = await ajaxEmailCode_v3(params);
    return res;
  },
  async sendVerifyCode({ commit }, params) {
    const res = await ajaxSendVerifyCode(params);
    return res;
  },
  async sendVerifyCodeByGG({ commit }, params) {
    const res = await ajaxSendVerifyCodeByGG(params);
    return res;
  },
  // 发送邮箱码
  async ajaxSignUp({ commit }, params) {
    const res = await signUp(params);
    return res;
  },
  // 找回密码
  async ajaxForget({ commit }, params) {
    const res = await forgetPassword(params);
    return res;
  },

  // -------首页-------
  // 发送邮箱码
  async getInviteCodeStatus({ commit }, region) {
    const res = await ajaxInviteCodeStatus({ region });
    try {
      commit(INVITECODE_STATUS_CODE, res.ret.status);
    } catch (error) {
      commit(INVITECODE_STATUS_CODE, false);
    }
  },
  // 当前用户可用邀请码
  async getAbleList({ commit }, params) {
    const res = await ajaxGetAbleList(params);
    try {
      if (res.ret.mainland && res.ret.mainland.length) {
        commit(GET_MAINLAND_LIST, res.ret.mainland);
      } else {
        commit(GET_MAINLAND_LIST, NO_CONTENT);
      }
    } catch (error) {
      commit(GET_MAINLAND_LIST, NO_CONTENT);
    }
    try {
      if (res.ret.non_mainland && res.ret.non_mainland.length) {
        commit(GET_NON_MAINLAND_LIST, res.ret.non_mainland);
      } else {
        commit(GET_NON_MAINLAND_LIST, NO_CONTENT);
      }
    } catch (error) {
      commit(GET_NON_MAINLAND_LIST, NO_CONTENT);
    }
    try {
      if (res.ret.calculate && res.ret.calculate.length) {
        commit(GET_CALCULATE_LIST, res.ret.calculate);
      } else {
        commit(GET_CALCULATE_LIST, NO_CONTENT);
      }
    } catch (error) {
      commit(GET_CALCULATE_LIST, NO_CONTENT);
    }
  },
  // 领取邀请码
  async getInviteCode({ commit }, params) {
    const res = await ajaxGetInviteCode(params);
    return res;
  },
  //  获取用户信息
  async getUserInfo({ commit }, params) {
    const res = await ajaxGetUserInfo(params);
    try {
      if (res.ret && res.ret.email) {
        if (!res.ret.telVerStatus) {
          window.href = '/contact';
        }
      }
      commit(GET_USER_INFO, res.ret.email);
    } catch (error) {
      commit(GET_USER_INFO, '');
    }
    return res;
  },
  //  获取IP信息
  async getIPInfo({ commit }) {
    const res = await ajaxIPInfo();
    // const res = {"country":"本机地址","message":"get user info successfully"};
    try {
      // .io自动跳转.work
      const country = res.country;
      const host = window.location.host;
      if (country == '中国' && (host == 'console.bonuscloud.io' || host.includes('8080'))) {
        window.location.href = 'http://console.bonuscloud.work';
      }

      commit(GET_COUNTRY_INFO, res.country);
    } catch (error) {
      commit(GET_COUNTRY_INFO, '');
    }
    return res;
  },
  //  修改密码
  async changePw({ commit }, params) {
    const res = await ajaxChangePw(params);
    return res;
  },
  //  获取硬件列表
  async getHardList({ commit }, params) {
    const res = await ajaxHardList(params);
    // const res = {"code":200,"ret":{"list":[{"stable":"低","note":"1855","id":"3ddfd3da-4ad1-4b6a-8484-5d357a5c28bd1","mac_address":"fc:7c:02:4f:50:9d","bcode":"0921-17d17ead-26e8-4633-89cc-29043694daeb","cpu_count":4,"mem_size":"1.80G","storage_size":"238.00G","used_ext_storage_size":"176.65G","schedule":true,"calNeeds":"高","nat":3,"tx_bw":"0.00","task_status":"Running","portmap":"NAT-failed","task_solution":"normal","bind_at":"2019-09-21 09:46:24","info":"v0.4.5","noteStatus":true,"nat_upd_at":"2019-12-10 10:05:43","portmap_upd_at":"2019-12-12 07:26:25","task_list":"A-2-100","task_map": [{"task": "C-1-200","id": "9f481922-5c8c-48e2-843f-0659c60a50d1"},{"task": "D-1-20","id": "0f0c9e81-0a54-4df8-8b5e-9cc66440aebc"}],"alreadyHasTaskType": ["C","D"],"auto_schedule":true , "allow_manual_schedule":true,"manual_schedule_candidate":{"A-1-100":"ce322528-6af8-42e3-8866-881adef92351","A-1-200":"29b44458-c4f1-4b0b-84fd-d4bfd3455965", "A-2-100":"29b44458-c4f1-4b0b-84fd-d4bfd3455965", "A-2-200":"29b44458-c4f1-4b0b-84fd-d4bfd3455965", "A-3-300":"29b44458-c4f1-4b0b-84fd-d4bfd3455965", "A-3-400":"29b44458-c4f1-4b0b-84fd-d4bfd3455965"},"last_manual_schedule_at":0,"manual_schedule_status":true},{"stable":"低","note":"1855","id":"3ddfd3da-4ad1-4b6a-8484-5d357a5c28bd","mac_address":"fc:7c:02:4f:50:9d","bcode":"0921-17d17ead-26e8-4633-89cc-29043694daeb","cpu_count":4,"mem_size":"1.80G","storage_size":"238.00G","used_ext_storage_size":"176.65G","schedule":true,"calNeeds":"高","nat":3,"tx_bw":"0.00","task_status":"Running","portmap":"NAT-failed","task_solution":"normal","bind_at":"2019-09-21 09:46:24","info":"v0.4.5","noteStatus":true,"nat_upd_at":"2019-12-10 10:05:43","portmap_upd_at":"2019-12-12 07:26:25","task_list":"A-2-100","manual_schedule_candidate":{"A-3-300":"ce322528-6af8-42e3-8866-881adef92351", "A-1-100":"ce322528-6af8-42e3-8866-881adef92351","A-1-200":"29b44458-c4f1-4b0b-84fd-d4bfd3455965"},"last_manual_schedule_at":0,"manual_schedule_status":true}],"deviceLength":100,"pageSize":20,"currentPage":"2"},"message":"get device list successfully"}
    try {
      if (params.GETRESULT) {
        if (res.ret) {
          return res.ret;
        }
      } else if (res.ret.list && res.ret.list.length > 0) {
        commit(GET_HARDLIST, res.ret);
      } else {
        commit(GET_HARDLIST, NO_CONTENT);
      }
    } catch (error) {
      commit(GET_HARDLIST, {});
    }
  },
  //  搜索硬件
  async getDeviceDetail({ commit }, params) {
    const res = await ajaxDeviceDetail(params);
    commit(GET_SEARCH_LIST, res.ret.list);
  },
  //  搜索硬件
  async addDeviceNotes({ commit }, params) {
    const res = await ajaxDeviceNotes(params);
    return res;
  },
  //  获取硬件列表
  async unbindHard({ commit }, params) {
    const res = await ajaxUnbindHard(params);
    return res;
  },
  //  获取用户总收益
  async getAllRevenue({ commit }, params) {
    const res = await ajaxAllRevenue(params);
    try {
      // if (params.type === 'all') {
      commit(GET_ALL_RENVUE, res.ret);
      // } else if (params.type === 'refer') {
      //   commit(GET_LASTDAY_INVITE, res.ret.revenue);
      // } else if (params.type === 'account') {
      //   commit(ACCOUNT_LASTDAY_REVENUE, res.ret.revenue);
      // }
      return res;
    } catch (error) {
      console.log(error);
    }
    return res;
  },
  //  获取用户单台设备收益
  async getRevenueDetail({ commit }, params) {
    const res = await ajaxRevenueDetail(params);
    // const res = {"code": 200,"ret": {"detailList": [{"note": "12","revenue": "21.94336","networkRevenue": 21.943363,"calculateRevenue": 0,"noteStatus": true,"id": "02868269-597b-4a40-aa3f-0850a695bf21","tx_bw": "32.89","mac_address": "fc:7c:02:4c:7a:52"},],"deviceLength": 4,"pageSize": "4","currentPage": "1","allDevices": [],"totalBxc": {"bxc": 974.246264,"task_bxc": 974.246264,"online_bxc": 0}}};
    try {
      if (params.GETRESULT) {
        return res.ret;
      }
      commit(GET_RENVUE_DETAIL, res.ret);
    } catch (error) {
      commit(GET_RENVUE_DETAIL, 'NONE');
    }
    return res;
  },
  //  获取用户邀请收益
  async getInviteDetail({ commit }, params) {
    const res = await ajaxInviteDetail(params);
    try {
      commit(GET_INVITE_DETAIL, res.ret || {});
    } catch (error) {
      commit(GET_INVITE_DETAIL, 'NONE');
    }
    return res;
  },
  //  获取用户推荐信息
  async getRecommendInfo({ commit }) {
    const res = await ajaxRecommendInfo();
    try {
      const recommenInfo = `${window.location.href}signUp?${res.ret.user}`;
      commit(GET_RECOMMEND_INFO, recommenInfo);
    } catch (error) {
      commit(GET_RECOMMEND_INFO, '');
    }
  },
  //  获取用户推荐数
  async getRecommendCount({ commit }) {
    const res = await ajaxRecommendCount();
    try {
      commit(GET_RECOMMEND_COUNT, res.count);
    } catch (error) {
      commit(GET_RECOMMEND_COUNT, 0);
    }
  },
  //  获取用户钱包绑定地址
  async getWalletAddress({ commit }) {
    const res = await ajaxWalletAddress();
    try {
      commit(GET_WALLET_ADDRESS, res.ret.eth_address || 'NO_ADDRESS');
      commit(GET_WALLET_STATUS, res.ret.eth_verify_status);
    } catch (error) {
      commit(GET_WALLET_ADDRESS, 'NO_ADDRESS');
      commit(GET_WALLET_STATUS, false);
    }
  },
  //   绑定钱包地址
  async bindWalletAddress({ commit }, params) {
    const res = await ajaxBindAddress(params);
    return res;
  },
  //   解绑钱包地址
  async commitUnbindAddress({ commit }) {
    const res = await ajaxUnbindAddress();
    return res;
  },
  // 获取验证码js地址
  async getVertifUrl({ commit }, params) {
    const res = await ajaxVertifUrl(params);
    return res;
  },

  //  获取提现列表
  async getWithdrawalList({ commit }, params) {
    const res = await ajaxWithdrawalList(params);
    let commitStatus = 'done';
    try {
      res.data.data.map((val) => {
        if (val.status === 'created') {
          commitStatus = 'created';
        }
        val.created_at = moment(val.created_at).utc().format('YYYY-MM-DD hh:mm:ss');
        val.eth_browser = `https://etherscan.io/tx/${val.transaction}`;
      });
      commit(GET_WITHDRAWAL_LIST, res.data.data);
      commit(GET_WITHDRAWAL_STAUTS, commitStatus);
    } catch (error) {
      commit(GET_WITHDRAWAL_LIST, 'NONE');
    }
  },
  //  获取提现余额
  async getWithdrawalBalance({ commit }, params) {
    const res = await ajaxWithdrawalBalance(params);
    try {
      if (params && params.type && params.type == 'admin') {
        return res;
      }
      if (res.data && res.data.balance) {
        commit(GET_BALANCE, parseInt(Number(res.data.balance.amount)));

        if (res.withdrawalStatus === 'closed') {
          commit(GET_WITHDRAWAL_STAUTS, 'closed');
        }
      } else {
        commit(GET_BALANCE, '-');
      }
    } catch (error) {
      commit(GET_BALANCE, 'NONE');
    }
  },
  //  提现
  async commitWithdrawal({ commit }, params) {
    const res = await ajaxCommitWithdrawal(params);
    return res;
  },
  //  查询设备监控信息
  async getDeviceWatchDetail({ commit }, params) {
    const res = await ajaxDeviceWatchDetail(params);
    // const res = { "data": { "devs_info_log": [{ "time": 1555447200000, "ext_storage_size": 125627793408, "tx_bandwidth": 49146757, "schedule": true, "nat": 6, "health": 159, "stable": 282 }, { "time": 1555447500000, "ext_storage_size": 125627793408, "tx_bandwidth": 49146757, "schedule": true, "nat": 6, "health": 158, "stable": 278 }, { "time": 1555447800000, "ext_storage_size": 125627793408, "tx_bandwidth": 49146757, "schedule": true, "nat": 6, "health": 158, "stable": 274 }, { "time": 1555448100000, "ext_storage_size": 125627793408, "tx_bandwidth": 49146757, "schedule": true, "nat": 6, "health": 157, "stable": 271 }, { "time": 1555448400000, "ext_storage_size": 125627793408, "tx_bandwidth": 49146757, "schedule": true, "nat": 6, "health": 157, "stable": 267 }, { "time": 1555448700000, "ext_storage_size": 125627793408, "tx_bandwidth": 49146757, "schedule": true, "nat": 6, "health": 156, "stable": 263 }, { "time": 1555449000000, "ext_storage_size": 125627793408, "tx_bandwidth": 49146757, "schedule": true, "nat": 6, "health": 156, "stable": 260 }, { "time": 1555449300000, "ext_storage_size": 125627793408, "tx_bandwidth": 49146757, "schedule": true, "nat": 6, "health": 155, "stable": 256 }, { "time": 1555449600000, "ext_storage_size": 125627793408, "tx_bandwidth": 49146757, "schedule": true, "nat": 6, "health": 155, "stable": 253 }] } };
    // const res = {"data":{"devs_info_log":[]}};
    return res.data.devs_info_log || [];
  },
  //  查询全网贡献
  async getNetworkContribution({ commit }, params) {
    const res = await ajaxNetworkContribution(params);
    commit(GET_NETWORK_CONTRIBUTION, res.data);
  },
  //  查询设备调度
  async getDeviceOverview({ commit }, params) {
    const res = await ajaxDeviceOverview(params);
    commit(GET_DEVICE_OVERVIEW, res.count);
  },
  //
  async setFiltertype({ commit }, type) {
    commit(SET_FILTER_TYPE, type);
  },
  //  查询设备调度
  async getDevicePcdnFlow({ commit }, data) {
    const res = await ajaxPcdnFlow(data);
    return res || {};
  },
  //  设备重启
  async restartDevice({ commit }, data) {
    const res = await ajaxRestartDevice(data);
    return res || {};
  },
  //  获取过去七天bxc价格
  async getLastSevenDayPrice({ commit }, data) {
    const res = await ajaxLastSevenDayPrice(data);
    commit(SET_LAST_SEVEN_PRICE, res.data);
  },
  //  提交回购
  async commitBuyBack({ commit }, data) {
    const res = await ajaxCommitBuyBack(data);
    return res;
  },
  //  回购列表
  async getBuyBackList({ commit }, data) {
    const res = await ajaxBuyBackList(data);
    commit(BUYBACK_LIST, res.data);
  },
  //  回购地址
  async getBuybackAddress({ commit }, data) {
    const res = await ajaxBuybackAddress(data);
    return res.data;
  },
  //  权限限制
  async getBuyBackAuth({ commit }, data) {
    const res = await ajaxBuyBackAuth(data);
    commit(BUYBACK_AUTH, res.data);
  },
  //  任务切换
  async changeTaskSchedule({ commit }, data) {
    const res = await ajaxTaskSchedule(data);
    // return [{"result":{"status":"success"}},{"result":{"status":"success"}}];
    return res;
  },
  // 获取用户openId
  async getWechatInfo({ commit }, data) {
    console.log(data);
    const res = await ajaxWechatInfo(data);
    console.log(res);
    commit(GET_WECHAT_INFO, res);
    return res;
  },
  // 绑定微信和博纳云账号
  async bindWechatEmail({ commit }, data) {
    const res = await ajaxWechatEmail(data);
    return res;
  },
  // 绑定微信和博纳云账号
  async getDeviceStatus({ commit }, data) {
    const res = await ajaxDeviceStatus(data);
    return res;
  },
  // 解绑
  async unBindWechatEmail({ commit }, data) {
    const res = await ajaxUnbindWechat(data);
    return res;
  },
  // 获取汇聚拨号配置
  async getDialConfig({ commit }, data) {
    const res = await ajaxDialConfig(data);
    // const res = {"status":200,"data":[]};
    if (res.data && res.data.length) {
      commit(GET_DIAL_CONFIG, res.data);
    } else if (data && data.configed) {
      commit(GET_DIAL_CONFIG, []);
    } else {
      commit(GET_DIAL_CONFIG, 'NODATA');
    }
  },
  // 获取汇聚拨号配置
  async commitDialConfig({ commit }, data) {
    const res = await ajaxCommitDial(data);
    return res;
  },
  // 删除汇聚拨号配置
  async deleteDialConfig({ commit }, data) {
    const res = await ajaxDeleteDial(data);
    return res;
  },

  // 获取汇聚拨号配置
  async getOneConfig({ commit }, data) {
    const res = await ajaxGetOneDial(data);
    return res;
  },
  // 联系方式
  async getContact({ commit }, data) {
    const res = await ajaxGetContact(data);
    // return {"code":200,"data":{"tel":"123","user_name":"123","contact":"123"}};
    return res;
  },
  // set联系方式
  async setContact({ commit }, data) {
    const res = await ajaxSetContact(data);
    return res;
  },


  // set节点
  async setStandardNode({ commit }, data) {
    const res = await ajaxSetStandardNode(data);
    return res;
  },
  // get节点
  async getStandardNode({ commit }, data) {
    const res = await ajaxGetStandardNode(data);
    // const res = {"status": 200,"data": [{"_id": 13,"_type": 1,"ci_type": "server","ci_type_alias": "服务器","city": "盐城","country": "中国","operator": "移动","province": "江苏","serverAccount": "csbt@qq.com","serverBcode": "0629-5209c45a-4339-46be-bd24-123","serverDeployStatus": "0","serverExtIP": "120.30.162","serverHostname": "dc-js-yancheng-cm01","serverID": "11","serverNetType": "0","serverNote": "机房移动万兆","serverOnlineDate": "2019-07-01 00:00:00","serverOwner": "施方辰","serverOwnerID": "123","serverPasswd": "Yv7VsB0LqJ1W","serverRelatedID": "11","serverService": "dcache","serverServiceID": "E9FD2FDDAED40CD0","serverServiceStatus": "运行","cpu_count": 40,"status": "online","mem_size": "125.83G","storage_size": "0.00G"},]};
    if (data && data.serverID) {
      return res.data[0];
    }
    if (res.data && res.data.length) {
      commit(GET_Node_CONFIG, res.data);
      return res.data;
    }
    commit(GET_Node_CONFIG, 'NODATA');
  },
  // 删除配置
  async deleteNodeConfig({ commit }, data) {
    const res = await ajaxDeleteNode(data);
    return res;
  },
  // 设置配置
  async setNodesDialConfig({ commit }, data) {
    const res = await ajaxSetNodesDialConfig(data);
    return res;
  },
  // 设置配置
  async setAdminNodesDialConfig({ commit }, data) {
    const res = await ajaxSetAdminNodesDialConfig(data);
    return res;
  },
  // 获取admin node信息
  async getAdminStandardNode({ commit }, data) {
    const res = await ajaxAdminStandardNode(data);
    return res;
  },
  // 获取admin node信息
  async getAdminContact({ commit }, data) {
    const res = await ajaxAdminContact(data);
    return res;
  },
  // 设备通知
  async setNotify({ commit }, data) {
    const res = await ajaxSetNotify(data);
    return res;
  },
  // 查看密码
  async getPassword({ commit }, data) {
    const res = await ajaxPasswordByBcode(data);
    return res;
  },
  // 获取京东卡兑换信息
  async getExchangeInfo({ commit }, data) {
    const res = await ajaxExchangeInfo(data);
    commit(GET_EXCHANGE_INFO, res.data);
  },
  async commitExchange({ commit }, data) {
    const res = await ajaxCommitExchange(data);
    return res;
  },
  async getJDOrderPass({ commit }, data) {
    const res = await ajaxJDOrderPass(data);
    // const res = {"data":[{"card":"DFC1-6858-C618-42D5"}]};
    return res;
  },
  // 兑换列表
  async getExchangeList({ commit }, data) {
    const res = await ajaxExchangeList(data);
    // const res = {"data":[{"id":1,"userId":"839be7a0cd5f11e8a0fc6b03f7abdc77","timestamp":1578902304656,"JDTimestamp":1578902524700,"exchangeStatus":"2","transactionId":"JDFKJHDKFHF123123wDS","JDCardCount":1,"exchangeJDMoney":1,"needBXCCount":55,"RMBPrice":0,"JDCardMoney":1,"orderId":"","orderPass":"","time":"2020-01-13 15:58:24"},{"id":2,"userId":"839be7a0cd5f11e8a0fc6b03f7abdc77","timestamp":1578902704723,"JDTimestamp":1578902706007,"exchangeStatus":"2","transactionId":"JDFKJHDKFHF123123wDS","JDCardCount":2,"exchangeJDMoney":2,"needBXCCount":109,"RMBPrice":0,"JDCardMoney":1,"orderId":"","orderPass":"","time":"2020-01-13 16:05:04"},{"id":3,"userId":"839be7a0cd5f11e8a0fc6b03f7abdc77","timestamp":1578907780000,"JDTimestamp":1578907951153,"exchangeStatus":"2","transactionId":"0dc3299d-7f8a-42c8-a1b2-7a22b4b012c7","JDCardCount":1,"exchangeJDMoney":1,"needBXCCount":381,"RMBPrice":0,"JDCardMoney":1,"orderId":"","orderPass":"","time":"2020-01-13 17:29:40"},{"id":5,"userId":"839be7a0cd5f11e8a0fc6b03f7abdc77","timestamp":1578908193000,"JDTimestamp":1578908221198,"exchangeStatus":"2","transactionId":"91c67244-ad14-4d86-85de-d2b3e2de3645","JDCardCount":1,"exchangeJDMoney":1,"needBXCCount":381,"RMBPrice":0,"JDCardMoney":1,"orderId":"","orderPass":"","time":"2020-01-13 17:36:33"},{"id":6,"userId":"839be7a0cd5f11e8a0fc6b03f7abdc77","timestamp":1578908623000,"JDTimestamp":1578909372751,"exchangeStatus":"2","transactionId":"c2d5634d-2eb2-492f-bc07-a8e1717a72d8","JDCardCount":1,"exchangeJDMoney":1,"needBXCCount":381,"RMBPrice":0,"JDCardMoney":1,"orderId":"","orderPass":"","time":"2020-01-13 17:43:43"}]};
    commit(GET_EXCHANGE_LIST, res.data);
  },
  // 拨号状态
  async getDialStatus({ commit }, data) {
    const res = await ajaxDialStatus(data);
    commit(GET_DIAL_STATUS, res);
  },
  // 修改带宽
  async updateBand({ commit }, data) {
    const res = await ajaxUpdateBand(data);
    return res;
  },
  async getNodeInfByBcode({ commit }, data) {
    const res = await ajaxNodeInfoByCode(data);
    // let res = {"cpuResult": [{"time": 1582730700000,"usage_idle": 0},],"memResult": [{"time": 1582710000000,"used": 0,"used_percent": 0},],"diskResult": {"sdb": [{"time": 1582698000000,"total": 984370356224,"used": 824748298240,"used_percent": 84.6458666226958}],},"diskioResult": {"sda": [{"time": 1582699500000,"io_util": 0.26366666666666666}],},"flowResult": [{"time": 1582686600000,"in_bps": 330926358,"out_bps": 20486703842},]};
    return res;
  },
  async getWhiteBalance({ commit }, data) {
    const res = await ajaxWhiteBalance(data);
    return res;
  },
  async updateCmbdByAdmin({ commit }, data) {
    const res = await ajaxUpdateByAdmin(data);
    return res;
  },
  async insertCmbdByAdmin({ commit }, data) {
    const res = await ajaxInsertCmbdByAdmin(data);
    return res;
  },
  async getServerByAdmin({ commit }, data) {
    const res = await ajaxServerByAdmin(data);
    return res;
  },
  async getDeployStatus({ commit }, data) {
    const res = await ajaxGetRedisStatus(data);
    return res;
  },
  async getLastSevenRevenue({ commit }, data) {
    const res = await ajaxLastSevenRevenue(data);
    return res;
  },
  async setServerLabel({ commit }, data) {
    const res = await ajaxServerLabel(data);
    return res;
  },
  async getLimitExchange({ commit }, data) {
    const res = await ajaxLimitExchange(data);
    return res;
  },
  async getCrmConfig({ commit }, data) {
    const res = await ajaxCrmConfig(data);
    return res;
  },
  async setStatus({ commit }, data) {
    const res = await ajaxSetStatus(data);
    return res;
  },
  async setTask({ commit }, data) {
    const res = await ajaxSetTask(data);
    return res;
  },
  async getStatus({ commit }, data) {
    const res = await ajaxGetStatus(data);
    // return {
    //   message: '[{"open":false,"start":"","end":"","type":"A","openLimit":false,"cityList":[],"cityLimit":false},{"open":false,"start":"","end":"","type":"B","openLimit":false,"openLimitCount":{"联通":0,"电信":0,"移动":0},"cityList":[]},{"open":true,"start":"","end":"","type":"C","openLimit":false,"openLimitCount":{"联通":0,"电信":0,"移动":0},"cityList":[]},{"open":true,"start":"","end":"","type":"D","openLimit":true,"openLimitCount":{"联通":"0","电信":"0","移动":"999999999"},"cityList":["北京","天津","山东","山西","江苏","江西","河北","河南","浙江","湖北","上海"],"cityLimit":true},{"open":false,"start":"","end":"","type":"E","openLimit":false,"cityList":[]},{"open":false,"start":"","end":"","type":"F","openLimit":false,"cityList":[]},{"open":true,"start":"","end":"","type":"H","openLimit":false,"cityList":[],"cityLimit":false},{"open":false,"start":"","end":"","type":"I","openLimit":false,"cityList":[]},{"open":false,"start":"","end":"","type":"F+","openLimit":false,"cityList":[]}]'
    // }
    return res;
  },
  async setEmailToList({ commit }, data) {
    const res = await ajaxEmailToList(data);
    return res;
  },
  async setEmailAuth({ commit }, data) {
    const res = await ajaxEmailAuth(data);
    return res;
  },
  async getUserList({ commit }, data) {
    const res = await ajaxUserList(data);
    return res;
  },
  async setSendEmail({ commit }, data) {
    const res = await ajaxSendEmail(data);
    return res;
  },
  async changeZFBInfo({ commit }, data) {
    const res = await ajaxChangeZFBInfos(data);
    return res;
  },
  async getZFBInfo({ commit }, data) {
    const res = await ajaxGetZFBInfos(data);
    return res;
  },
  async getAutoWithList({ commit }, data) {
    const res = await ajaxAutoWithList(data);
    return res;
  },
  async setAutoWithStatus({ commit }, data) {
    const res = await ajaxAutoWithStatus(data);
    return res;
  },
  async getAutoUserList({ commit }, data) {
    const res = await ajaxAutoWithUserList(data);
    return res;
  },
  async setBalance({ commit }, data) {
    const res = await ajaxOperateBalance(data);
    return res;
  },
  async getBalanceList({ commit }, data) {
    const res = await ajaxBalanceList(data);
    return res;
  },
  async getInfo({ commit }, data) {
    const res = await ajaxInfo(data);
    return res;
  },

  // 新增获取我的钱包
  async getCollection({ commit }, data) {
    const res = await ajaxGetCollection(data);
    return res;
  },

  async setCollection({ commit }, data) {
    const res = await ajaxSetCollection(data);
    return res;
  },

  // 获取权限等级
  async getPermissionLevel({ commit }, data) {
    const res = await ajaxPermissionLevel(data);
    return res;
  },

  // 获取链上转账结果
  async getBuybackStatus({ commit }, params) {
    const res = await ajaxBuybackStatus(params);
    return res;
  },

  // 打款
  async setPayment({ commit }, params) {
    const res = await ajaxSetPayment(params);
    return res;
  },

  // 发起打款的状态
  async setPaymentWithStatus({ commit }, data) {
    const res = await ajaxSetPaymentWithStatus(data);
    return res;
  },

  // 获取故障设备
  async getDevErr({ commit }, data) {
    const res = await ajaxGetDevErr(data);
    return res;
  },

  // 查询故障设备
  async getDevErrBymac({ commit }, data) {
    const res = await ajaxGetDevErrBymac(data);
    return res;
  },

  // 设置设备备注
  async setServerTag({ commit }, data) {
    const res = await ajaxSetServerTag(data);
    return res;
  },

  // 查询id 解绑设备
  async unbindDev({ commit }, data) {
    const res = await ajaxUnbindDev(data);
    return res;
  },

  // 获取微信公众号用户tel（根据邮箱
  async getWechatTelFromEmail({ commit }, data) {
    const res = await ajaxWechatTelFromEmail(data);
    return res;
  },

  // 获取bp余额
  async getWechatBalance({ commit }, data) {
    const res = await ajaxWechatBalance(data);
    console.log(res);
    try {
      if (res.data && res.data.balance) {
        console.log(res.data);
        commit(GET_WECHAT_BANLANCE, parseInt(Number(res.data.balance.amount)));
        if (res.withdrawalStatus === 'closed') {
          commit(GET_WITHDRAWAL_STAUTS, 'closed');
        }
      } else {
        commit(GET_WECHAT_BANLANCE, '-');
      }
      return res;
    } catch (error) {
      commit(GET_WECHAT_BANLANCE, 'NONE');
    }
  },

  // 获取提现discount等信息
  async getWechatSevenDayPrice({ commit }, data) {
    const res = await ajaxWechatSevenDayPrice(data);
    commit(GET_WECHAT_SEVENDAYPRICE, res.data);
    return res;
  },

  // 微信发起提现
  async setWechatCommitBuyBack({ commit }, data) {
    const res = await ajaxWechatCommitBuyBack(data);
    return res;
  },

  // 获取京东卡兑换信息
  async getWechatExchangeInfo({ commit }, data) {
    const res = await ajaxWechatExchangeInfo(data);
    if (res.code === 200) {
      commit(GET_EXCHANGE_INFO, res.data);
    }
    return res;
  },

  // 发起京东卡兑换
  async setWechatCommitExchange({ commit }, data) {
    const res = await ajaxWechatCommitExchange(data);
    return res;
  },
  // 获取活动新旧设备收益详情
  async getActivityRevenue({ commit }, data) {
    const res = await ajaxActivityRevenue(data);
    return res;
  },
  // 活动累计总收益
  async getActivityAllRevenue({ commit }, data) {
    const res = await ajaxActivityAllRevenue(data);
    return res;
  },
  // 查询业务验收结果
  async getTaskAcceptanceRes({ commit }, data) {
    const res = await ajaxTaskAcceptanceRes(data);
    return res;
  },
  // 获取月账单详情
  async getBillDetails({ commit }, data) {
    const res = await ajaxGetBillDetails(data);
    return res;
  },

  // 更新账单确认状态
  async updateBillStatus({ commit }, data) {
    const res = await ajaxUpdateBillStatus(data);
    return res;
  },

  // 获取设备日95(账单详情中)
  async getBillBps({ commit }, data) {
    const res = await ajaxGetBillBps(data);
    return res;
  },

  // 根据主机名获取拨号信息（拨号状态页面中）
  async getDialByHostname({ }, data) {
    const res = await ajaxGetDialByHostname(data);
    return res;
  },

  // 拨号配置页面 根据服务关联配置id 获取server信息
  async getServerByDialID({ }, data) {
    const res = await ajaxGetServerByDialID(data);
    return res;
  },

  // 拨号
  async setDial({ }, data) {
    const res = await ajaxSetDial(data);
    return res;
  },

  // 记录保存后的拨号状态
  async savedStatus({ }, data) {
    const res = await ajaxSavedStatus(data);
    return res;
  },

  // 获取缺口数据
  async getGaps() {
    const res = await ajaxGetGaps();
    return res;
  },
  async setWechatAccountUnify({ commit }, data) {
    const res = await ajaxWechatAccountUnify(data);
    return res;
  },


  // 获取账单权限
  async getBillAuth({ commit }, data) {
    const res = await ajaxGetBillAuth(data);
    return res;
  },
  // 获取业务方
  async getBusiness({ commit }, data) {
    const res = await ajaxGetBusiness(data);
    console.log(res);
    if (res && res.items) {
      commit(GET_BUSINESS, res.items);
    }
    return res;
  },
  // 计算账单
  async calculateBill({ commit }, data) {
    const res = await ajaxCalculateBill(data);
    return res;
  },
  // 获取账单操作记录
  async getBillRecordList({ commit }, data) {
    const res = await ajaxGetBillRecordList(data);
    return res;
  },
  // 供给方账单上传
  async uploadSupplyBill({ commit }, data) {
    const res = await ajaxUploadSupplyBill(data);
    return res;
  },
  // 删除供给方账单
  async delSupplyBill({}, data) {
    const res = await ajaxDelSupplyBill(data);
    return res;
  },
  // 获取设备验收信息
  async getDeviceAcceptance({}, data) {
    const res = await ajaxGetDeviceAcceptance(data);
    return res;
  },
  // 设备验收
  async setDeviceAcceptance({}, data) {
    const res = await ajaxSetDeviceAcceptance(data);
    return res;
  },
  // 设备部署
  async setDeviceDeployment({}, data) {
    const res = await ajaxSetDeviceDeployment(data);
    return res;
  },
  // 下载中心用户操作记录
  async recordDownloadCenter({}, data) {
    const res = await ajaxRecordDownloadCenter(data);
    return res;
  },
  async getStandardNodeHostNameAndBcode() {
    const res = await ajaxGetStandardNodeHostNameAndBcode();
    return res;
  },
  async getetOutFlowRes({}, data) {
    const res = await ajaxGetetOutFlowRes(data);
    return res;
  },
  async getAbnormalDisk({}, data) {
    const res = await ajaxGetAbnormalDisk(data);
    return res;
  },
  async exportDialErrInfo({}, data) {
    const res = await ajaxExportDialErrInfo(data);
    return res;
  },
};

